import React from "react";
import { Link } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";

const PrivacyPolicy = () => {
  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            <div className="container">
              {/* Account Logo */}
              <div className="account-logo">
                <Link to="/">
                  <img src={Applogo} alt="Company Logo" />
                </Link>
              </div>
              {/* /Account Logo */}
              <div className="account-box" style={{ maxWidth: "800px" }}>
                <div className="account-wrapper">
                  <h3 className="account-title">Privacy Policy</h3>
                  <p className="account-subtitle text-muted">
                    Last updated: January 2025
                  </p>

                  <div className="privacy-content mt-4" style={{ textAlign: "left" }}>
                    <section className="mb-4">
                      <h5 className="text-primary">1. Introduction</h5>
                      <p>
                        Prince Ebeano Supermarket ("we", "our", or "us") is committed to protecting
                        the privacy of our employees and users of our HR Management System. This
                        Privacy Policy explains how we collect, use, disclose, and safeguard your
                        information when you use our HR application and services.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">2. Information We Collect</h5>
                      <p>We collect information that you provide directly to us, including:</p>
                      <ul>
                        <li><strong>Personal Information:</strong> Name, email address, phone number, date of birth, address, and government-issued identification numbers.</li>
                        <li><strong>Employment Information:</strong> Employee ID, department, designation, branch location, employment dates, and work history.</li>
                        <li><strong>Attendance Data:</strong> Clock-in/clock-out times, leave requests, and attendance records collected through biometric devices.</li>
                        <li><strong>Financial Information:</strong> Bank account details for payroll processing, loan applications, and salary information.</li>
                        <li><strong>Emergency Contacts:</strong> Next of kin information and emergency contact details.</li>
                        <li><strong>Biometric Data:</strong> Fingerprint or facial recognition data for attendance verification (where applicable).</li>
                      </ul>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">3. How We Use Your Information</h5>
                      <p>We use the collected information for the following purposes:</p>
                      <ul>
                        <li>Processing payroll and managing employee compensation</li>
                        <li>Tracking attendance and managing work schedules</li>
                        <li>Processing leave requests and managing time-off balances</li>
                        <li>Administering employee loans and benefits</li>
                        <li>Communicating important work-related information</li>
                        <li>Maintaining accurate employment records</li>
                        <li>Complying with legal and regulatory requirements</li>
                        <li>Improving our HR services and systems</li>
                      </ul>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">4. Data Storage and Security</h5>
                      <p>
                        We implement appropriate technical and organizational security measures to
                        protect your personal information against unauthorized access, alteration,
                        disclosure, or destruction. These measures include:
                      </p>
                      <ul>
                        <li>Encryption of sensitive data in transit and at rest</li>
                        <li>Secure access controls and authentication mechanisms</li>
                        <li>Regular security assessments and updates</li>
                        <li>Limited access to personal data on a need-to-know basis</li>
                        <li>Secure backup procedures</li>
                      </ul>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">5. Data Retention</h5>
                      <p>
                        We retain your personal information for as long as necessary to fulfill the
                        purposes for which it was collected, including to satisfy legal, accounting,
                        or reporting requirements. Employment records are typically retained for the
                        duration of employment and for a period thereafter as required by applicable
                        labor laws.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">6. Your Rights</h5>
                      <p>You have the following rights regarding your personal information:</p>
                      <ul>
                        <li><strong>Access:</strong> Request access to your personal data held by us</li>
                        <li><strong>Correction:</strong> Request correction of inaccurate or incomplete data</li>
                        <li><strong>Deletion:</strong> Request deletion of your data (subject to legal requirements)</li>
                        <li><strong>Portability:</strong> Request a copy of your data in a portable format</li>
                        <li><strong>Objection:</strong> Object to certain processing of your data</li>
                      </ul>
                      <p>
                        To exercise any of these rights, please contact the HR department or use the
                        "Contact Admin" feature in the application.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">7. Third-Party Services</h5>
                      <p>
                        We may use third-party service providers to assist in operating our HR system,
                        such as cloud hosting providers and biometric device manufacturers. These
                        providers are contractually obligated to protect your information and use it
                        only for the purposes we specify.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">8. Changes to This Policy</h5>
                      <p>
                        We may update this Privacy Policy from time to time. We will notify you of
                        any significant changes by posting the new Privacy Policy on this page and
                        updating the "Last updated" date. Continued use of the application after
                        changes constitutes acceptance of the updated policy.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">9. Contact Us</h5>
                      <p>
                        If you have any questions about this Privacy Policy or our data practices,
                        please contact:
                      </p>
                      <ul className="list-unstyled">
                        <li><strong>HR Department</strong></li>
                        <li>Prince Ebeano Supermarket</li>
                        <li>Email: hr@princeebeano.com</li>
                      </ul>
                    </section>
                  </div>

                  <div className="account-footer mt-4">
                    <p>
                      <Link to="/" className="btn btn-primary">
                        Back to Login
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
